import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import Pipeline from "../../../pipelines/components/Pipeline/Pipeline";

export default function DistributionPipelineView({ distribution }) {
	const { t } = useTranslation();

	return (
		<>
			<Header as="h3">{t("pipeline", "Pipeline")}</Header>

			<Card fluid>
				<Card.Content>
					<LoadingContext data={distribution.pipeline?.steps}>
						<Pipeline document={distribution} />
					</LoadingContext>
				</Card.Content>
			</Card>
		</>
	);
}
